





















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class NotFoundModal extends Vue {
  @Prop() private msg!: string;

  created() {
    this.$nextTick(() => this.$bvModal.show("modal-404"));
  }

  handleOk() {
    this.$router.push("/");
  }

  handleCancel() {
    this.$router.push("/");
  }

}
